import React from 'react'
import { toast, ToastContainer } from 'react-toastify'

import FpTranslate from 'forepaas/translate'

class FpToastifyRenderer extends React.Component {
  render () {
    return <ToastContainer
      type='default'
      position='top-right'
      autoClose={5000}
      hideProgressBar
      closeOnClick
      pauseOnHover
    />
  }
}

class FpToastify {
  constructor () {
    this.name = 'toto'
  }

  pop (message, type) {
    let types = ['success', 'error', 'warn', 'info']
    if (types.indexOf(type) === -1) {
      console.error(`Toaster only have those types : ${types.join(', ')}`)
      return
    }
    // Always show the toast, allowing stacking
    toast[type](FpTranslate(message))
  }
  success (message) {
    this.pop(message, 'success')
  }
  error (message) {
    this.pop(message, 'error')
  }
  info (message) {
    this.pop(message, 'info')
  }
  warn (message) {
    this.pop(message, 'warn')
  }

  render () {
    return FpToastifyRenderer
  }
}

export default new FpToastify()
